// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  clueId: __t.u64().primaryKey().name("clue_id"),
  identity: __t.identity(),
  mysteryKey: __t.string().name("mystery_key"),
  step: __t.u8(),
  title: __t.string(),
  source: __t.string(),
  place: __t.string(),
  text: __t.string(),
  question: __t.string(),
  nextLabel: __t.string().name("next_label"),
  nextSystem: __t.string().name("next_system"),
  nextX: __t.f64().name("next_x"),
  nextY: __t.f64().name("next_y"),
  nextZ: __t.f64().name("next_z"),
  at: __t.timestamp(),
});
